// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1RGBC","box":"WorkspacesBox_box__2VfmO","node":"WorkspacesBox_node__3t8I_"};